export type SortDirection = 'asc' | 'desc'

export const parsePositiveIntegerParam = (rawValue: string | null, fallback: number): number => {
  const parsedValue = Number(rawValue ?? '')
  if (!Number.isFinite(parsedValue) || !Number.isInteger(parsedValue) || parsedValue <= 0) {
    return fallback
  }
  return parsedValue
}

export const parseSortDirParam = (rawValue: string | null): SortDirection | undefined => {
  if (rawValue === 'asc' || rawValue === 'desc') {
    return rawValue
  }
  return undefined
}

export const parseEnumCsvParam = <T extends string>(
  searchParams: URLSearchParams,
  key: string,
  allowedValues: readonly T[]
): T[] => {
  const rawValue = searchParams.get(key)

  if (!rawValue) {
    return []
  }

  const allowedValueSet = new Set<string>(allowedValues)

  return rawValue
    .split(',')
    .map((value) => value.trim())
    .filter((value): value is T => value.length > 0 && allowedValueSet.has(value))
}
